import Spinner from '../Spinner';

const PageSpinner = () => (
  <h2
    id="loading-settings"
    className="text-center"
    style={{
      padding: '50px',
    }}
  >
    <Spinner />
  </h2>
);

// eslint-disable-next-line import/no-default-export
export default PageSpinner;
